// Module generated from Markdown by Markdown Component Loader v1.1.0
import React from 'react';
import PropTypes from 'prop-types';

MarkdownComponent.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object
};

function MarkdownComponent(props) {
  const { className, style } = props;

  return (
    <div className={className} style={style}>
      <h3 id="december-17-2021">December 17, 2021</h3>
      <ul>
      <li>(v1) Updated <code>directDeposit.accountType</code> enum for 526 form 'validate' endpoint to be case insensitive <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/8716">#8716</a></li>
      </ul>
      <h3 id="december-14-2021">December 14, 2021</h3>
      <ul>
      <li>(v1) Updated <code>directDeposit.accountType</code> enum for 526 form to be case insensitive <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/8655">#8655</a></li>
      </ul>
      <h3 id="may-3-2021">May 3, 2021</h3>
      <ul>
      <li>(v0 &amp; v1) Fixed documentation to properly define consentLimits for a POST 2122 submission <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/6728">#6728</a></li>
      </ul>
      <h3 id="april-22-2021">April 22, 2021</h3>
      <ul>
      <li>(v1) &quot;/forms/2122/active&quot; now returns current and previous POA regardless of prior submissions to Lighthouse Claims API <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/6621">#6621</a></li>
      <li>(v0 &amp; v1) Fixed bug where a Veteran was unable to submit a POA change for a previously used Representative <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/6486">#6486</a></li>
      <li>(v0 &amp; v1) Fixed bug where some service branch options within a disability claim submission were invalid <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/6640">#6640</a></li>
      </ul>
      <h3 id="march-30-2021">March 30, 2021</h3>
      <ul>
      <li>(v0 &amp; v1) Deprecate &quot;schema&quot; endpoint for 526 form <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/6289">#6289</a></li>
      <li>(v0 &amp; v1) Deprecate &quot;schema&quot; endpoint for 0966 form <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/6289">#6289</a></li>
      <li>(v0 &amp; v1) Deprecate &quot;schema&quot; endpoint for 2122 form <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/6289">#6289</a></li>
      <li>(v0 &amp; v1) Deprecate &quot;validate&quot; endpoint for 526 form <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/6289">#6289</a></li>
      <li>(v0 &amp; v1) Deprecate &quot;validate&quot; endpoint for 0966 form <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/6289">#6289</a></li>
      <li>(v0 &amp; v1) Deprecate &quot;validate&quot; endpoint for 2122 form <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/6289">#6289</a></li>
      <li>(v0 &amp; v1) Reduce valid flashes to 526 endpoint to shorter more relevant list <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/6256">#6256</a></li>
      </ul>
      <hr />
      <h3 id="january-4-2021">January 4, 2021</h3>
      <ul>
      <li>(v0 &amp; v1) Write flashes to BGS when 526 claims are submitted for auto-establishment <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/5248">#5248</a></li>
      <li>(v0 &amp; v1) Write special issues to BGS when 526 claims are submitted for auto-establishment <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/5576">#5576</a></li>
      </ul>
      <hr />
      <h3 id="september-14-2020">September 14, 2020</h3>
      <p>(v0 &amp; v1) Add <code>validate</code> endpoint for 2122 form <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/4881">#4881</a></p>
      <hr />
      <h3 id="september-1-2020">September 1, 2020</h3>
      <p>Update claims API documentation <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/4783">#4783</a></p>
      <hr />
      <h3 id="august-25-2020">August 25, 2020</h3>
      <p>Migrate Intent to FIle from EVSS to BGS <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/4575">#4575</a></p>
      <hr />
      <h3 id="august-17-2020">August 17, 2020</h3>
      <p>Added camel inflected schemas to claims API <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/4730">#4730</a></p>
      <hr />
      <h3 id="august-7-2020">August 7, 2020</h3>
      <p>(v0 &amp; v1) Add <code>validate</code> endpoint for 0966 form <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/4656">#4656</a></p>
      <hr />
      <h3 id="july-16-2020">July 16, 2020</h3>
      <p>Ability to generate and upload a signed 2122 PDF form using submitted signatures <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/4463">#4463</a></p>
      <ul>
      <li>Updated schema changes for 2122</li>
      </ul>
      <hr />
      <h3 id="june-25-2020">June 25, 2020</h3>
      <p>(v0 &amp; v1) Updated <code>homelessSituationType</code> and <code>homelessnessRiskSituationType</code> enums <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/4383">#4383</a></p>
      <hr />
      <h3 id="june-17-2020">June 17, 2020</h3>
      <p>(v0 &amp; v1) Add optional base64 encoding information to documentation <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/4381">#4381</a></p>
      <hr />
      <h3 id="june-10-2020">June 10, 2020</h3>
      <p>The optional query parameter <code>prompt</code> has been added to the authorization flow.</p>
      <ul>
      <li>Supported prompts: login. If specified, the user will be forced to provide credentials regardless of session state. If omitted, an existing active session with the identity provider may not require the user to provide credentials.</li>
      </ul>
      <p><a href="https://github.com/department-of-veterans-affairs/vets-saml-proxy/pull/111">View code changes(s)</a></p>
      <hr />
      <h3 id="november-27-2019">November 27, 2019</h3>
      <p>(v0) Add &quot;claimDate&quot; field to set receipt dates for internal consumers <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/3596">#3596</a></p>
      <hr />
      <h3 id="november-20-2019">November 20, 2019</h3>
      <p>(v1) Require attachment for original claims submitted by representatives <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/3554">#3554</a></p>
      <hr />
      <h3 id="november-12-2019">November 12, 2019</h3>
      <p>(v1) Validate existence of previous claim to determine &quot;original claim&quot; status and require attachment in those cases <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/3471">#3471</a></p>
      <hr />
      <h3 id="september-24-2019">September 24, 2019</h3>
      <p>(v0 &amp; v1) Add &quot;autoCestPDFGenerationDisabled&quot; boolean field <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/3328">#3328</a></p>
      <hr />
      <h3 id="july-23-2019">July 23, 2019</h3>
      <p>(v1) Announced production support for external use of v1, allowing:</p>
      <ul>
      <li>Users with existing Power of Attorney to establish 526 claims on a Veteran's behalf</li>
      <li>Authenticated Veterans to establish 526 claims on their own behalf</li>
      </ul>
      <hr />
      <h3 id="june-25-2019">June 25, 2019</h3>
      <p>Creating ITF expiration validation for 526 <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/3119">#3119</a></p>
      <hr />
      <h3 id="june-17-2019">June 17, 2019</h3>
      <p>Add supporting documents to claims <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/3111">#3111</a></p>
      <hr />
      <h3 id="june-10-2019">June 10, 2019</h3>
      <p>Add machine readable source to errors <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/3097">#3097</a></p>
      <hr />
      <h3 id="june-3-2019">June 3, 2019</h3>
      <ul>
      <li>Add a couple specs for empty ITF requests <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/3083">#3083</a></li>
      <li>Upgrade Ruby to 2.4.5 <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/2995">#2995</a></li>
      </ul>
      <hr />
      <h3 id="may-30-2019">May 30, 2019</h3>
      <ul>
      <li>Adding logic to match claims detail and auto claim serializers <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/3061">#3061</a></li>
      <li>Adding Form Schema documentation and json api compliance <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/3075">#3075</a></li>
      </ul>
      <hr />
      <h3 id="may-28-2019">May 28, 2019</h3>
      <ul>
      <li>Rails 5.2.3 <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/2933">#2933</a></li>
      <li>Get request for displaying JSON Schema for each form <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/3072">#3072</a></li>
      </ul>
      <hr />
      <h3 id="may-20-2019">May 20, 2019</h3>
      <ul>
      <li>(v1) Claims docs fix <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/3055">#3055</a></li>
      <li>(v1) add edipi to from_identity call <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/3047">#3047</a></li>
      </ul>
      <hr />
      <h3 id="may-1-2019">May 1, 2019</h3>
      <ul>
      <li>(v1) Art.claims 404 <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/3015">#3015</a></li>
      <li>(v1) Rails 5.1 <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/2897">#2897</a></li>
      </ul>
      <hr />
      <h3 id="april-30-2019">April 30, 2019</h3>
      <p>(v1) Creating Swagger Blocks Documentation for Claims V1 <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/2952">#2952</a></p>
      <hr />
      <h3 id="april-23-2019">April 23, 2019</h3>
      <ul>
      <li>(v1) Check PoA with Okta <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/2990">#2990</a></li>
      <li>(v1) Intent To File Claims Api <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/2990">#2990</a></li>
      </ul>
      <hr />
      <h3 id="april-17-2019">April 17, 2019</h3>
      <p>(v1) Art.claims api schema <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/2965">#2965</a></p>
      <hr />
      <h3 id="april-12-2019">April 12, 2019</h3>
      <p>(v1) Verify PoA from OGC data <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/2951">#2951</a></p>
      <hr />
      <h3 id="april-11-2019">April 11, 2019</h3>
      <p>(v1) Add ability to set users from oauth token or headers <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/2949">#2949</a></p>
      <hr />
      <h3 id="april-9-2019">April 9, 2019</h3>
      <ul>
      <li>(v1) Upgrade API to Rails 5.0.7.2 <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/2833">#2833</a></li>
      <li>(v1 )Uploading Uploads to EVSS for Auto-CEST <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/2915">#2915</a></li>
      <li>(v1) 526 Additional Validations <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/2936">#2936</a></li>
      </ul>
      <hr />
      <h3 id="april-5-2019">April 5, 2019</h3>
      <p>(v1) Split off Claims v1 <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/2927">#2927</a></p>
      <hr />
      <h3 id="march-26-2019">March 26, 2019</h3>
      <p>(v0) Create mock override to test auto-establishment in staging <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/2908">#2908</a></p>
      <ul>
      <li>Our upstream partners limit the number of test submissions allowed in staging, so we now use mocked data by default.</li>
      </ul>
      <hr />
      <h3 id="march-21-2019">March 21, 2019</h3>
      <p>(v0) Fix security vulnerability in disability claim auto-establishment <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/2903">#2903</a></p>
      <hr />
      <h3 id="march-20-2019">March 20, 2019</h3>
      <p>(v0) Fix duplicate submissions for disability claim auto-establishment <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/2852">#2852</a></p>
      <hr />
      <h3 id="march-18-2019-claims">March 18, 2019</h3>
      <p>(v0) Add support for uploading documents to auto-established disability compensation claims <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/2868">#2868</a></p>
      <hr />
      <h3 id="march-15-2019">March 15, 2019</h3>
      <p>(v0) Improve Veteran lookup for disability claim auto-establishment and claim status <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/2863">#2863</a></p>
      <hr />
      <h3 id="january-8-2019">January 8, 2019</h3>
      <p>(v0) Implement initial VA internal-only disability claim auto-establishment <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/2824">#2824</a></p>
      <hr />
      <h3 id="january-8-2019-1">January 8, 2019</h3>
      <p>(v0) Implement Power of Attorney lookup for future v1 <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/2709">#2709</a></p>
      <hr />
      <h3 id="january-4-2019">January 4, 2019</h3>
      <p>(v0) Update claim statuses to be consistent with VA.gov <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/2701">#2701</a></p>
    </div>
  );
};

export default MarkdownComponent;
